export default __webpack_public_path__ + "static/media/jihyo3.bbb140b1.jpg";